// extracted by mini-css-extract-plugin
module.exports = {"wizardMainWrapper":"wizardMainWrapper_r95rOjBt","content":"content_3l-lrfB-","bot":"bot_LS9nVLCl","wizardImg":"wizardImg_1Nc_N98Z"};